module.exports = __webpack_public_path__ + "img/robo.c9375aeb.svg";